import { createContext } from 'react';

import { type MinimalUser } from '@/generated/model';

import type { ExtraFeature } from '@/app/routing/guards/extraFeatures';

export type UserContext = {
  user: MinimalUser;
  isToken: () => boolean;
  hasExtraFeature: (extraFeature: ExtraFeature) => boolean;
  logout: () => void;
};

export const ctxUser = createContext<UserContext | undefined>(undefined);

export function createUserContextValue(user: MinimalUser, logout: () => void): UserContext {
  return {
    user,
    isToken: () => user.isTokenUser,
    hasExtraFeature: (extraFeature: ExtraFeature) => user.extraFeatures?.includes(extraFeature) ?? false,
    logout,
  };
}
